import { useSelector } from 'react-redux';
import featureNames from '@utils/featureToggle/constants';
import { featureSelector } from '@store/common/selectors';

export const useNewFilterDialogEnabled = () => {
  return useSelector<any, boolean>(featureSelector(featureNames.NEW_FILTER_BUILDER));
};
